const func = ($target) => {
	window.loader.key("matchheight", function () {
		$target.find('[data-id="match-height"]').matchHeight();
	});
};

export default func;
